// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__-Ejgq","loader":"loader_loader__Psl4o","push":"loader_push__aP8lH"};